<template>
    <div class="wl-authentication-center">
        <div class="authentication-content">
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">申请认证中心的流程</span></h3>
            <div class="rz-flow-chart">
                <img src="../../assets/images/rz-flow-chart.png" alt="">
            </div>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">查看认证中心合作协议</span></h3>
            <div class="download-document-list">
                <div class="download-document-li clearfix">
                    <p class="p-document-text lf">北京中物联物流采购培训中心关于认证中心的合作协议2019版.doc</p>
                    <a class="download-link rh" href="javascript:;">点击下载</a>
                </div>
            </div>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">认证中心申请要求</span></h3>
            <div class="require-content">
                <ul>
                    <li><i class="wl-icon-dian"></i> 申请报告（包括申请项目类别、级别、地域，年最低保证培训人数）及申请表（加盖公章）；</li>
                    <li><i class="wl-icon-dian"></i> 营业执照或法人执照、组织机构代码证书、税务登记证（复印件加盖公章）；</li>
                    <li><i class="wl-icon-dian"></i> 单位管理制度及培训场地证明文件；</li>
                    <li class="clearfix">
                        <div class="report-left-title lf"><i class="wl-icon-dian"></i> <span> 项目分析报告：</span></div>
                        <div class="report-right-content lf">
                            <p>（1）单位介绍。要求越详细越好，至少包括单位背景、成立时间、单位规模、部门设置、主要业务等。</p>
                            <p>（2）曾经或正在开展的培训教育项目及进展情况、运作模式、合作单位，主要客户；</p>
                            <p>（3）所申请项目的营销方案，包括所申请项目在当地市场情况分析、开展该项目的SWOT分析、招生渠道、项目推广策略与计划等。</p>
                        </div>
                    </li>
                </ul>
            </div>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">认证中心申请表附件下载</span></h3>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>
